import React from 'react';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';
import { getServicesList, orderServiceList } from '../../Pharmacies/epics-pharmacies';
import { withRouter } from 'react-router-dom';
import { RoutePaths } from '../ClientRoutes';

const SortableItem = SortableElement(({ value, serviceId, pharmacyId, history }) => {
    return (
        <li className="qf-dragDropItem qf-small-text color-light-blue">
            <span className="qf-dragIcon">
                <i className="fa fa-ellipsis-v" aria-hidden="true" />
            </span>
            {value}
            <button className="qf-dragDromEditLink" onClick={() => history.push(RoutePaths.EDIT_PHARMACY_SERVICE(pharmacyId, serviceId))}>
                <i className="fa fa-pencil-square-o" />
            </button>
        </li>
    );
});

const SortableList = SortableContainer(items => {
    return (
        <ul className="qf-dragDropList">
            {(items.items || []).map((value, index) => (
                <SortableItem
                    key={`item-${index}`}
                    index={index}
                    value={value.title}
                    serviceId={value.id}
                    pharmacyId={items.pharmacyId}
                    history={items.history}
                />
            ))}
        </ul>
    );
});

class DragDropList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            appearance: this.props.appearance,
            pharmacyId: this.props.pharmacyId,
            title: this.props.language,
            language: '',
            items: []
        };
    }

    generateNewServiceList = (language, service) => {
        if (this.state.language === language) {
            this.setState({ ...this.state, items: service });
        }
    };

    componentWillReceiveProps(prevState, nextState) {
        this.setState({
            ...this.state,
            items: prevState.services.services,
            language: prevState.services.language
        });
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        this.setState({
            items: arrayMove(this.state.items, oldIndex, newIndex)
        });
        orderServiceList(this.state.items, this.state.pharmacyId, this.state.title)
            .then(() => {
                getServicesList(this.state.pharmacyId)
                    .then(response => {
                        (response || []).forEach((service, index) => {
                            this.generateNewServiceList(service.language, service.services);
                        });
                    })
                    .catch(err => {
                        console.log(err);
                    });
            })
            .catch(error => {});
    };

    render() {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="color-dark-gray mt-2 mb-2 qf-service-title">{this.state.title}</div>
                </div>
                <div className="col-12">
                    <hr className="qf-divider-line-drag-drop-list" />
                </div>
                <div className="col-12">
                    <SortableList
                        helperClass="qf-dragDropListSortable"
                        items={this.state.items}
                        pharmacyId={this.state.pharmacyId}
                        history={this.props.history}
                        appearance={this.state.appearance}
                        lockAxis="y"
                        onSortEnd={this.onSortEnd}
                        distance={10}
                    />
                </div>
            </div>
        );
    }
}

export default withRouter(DragDropList);



// WEBPACK FOOTER //
// ./src/customModules/Common/components/DragDropList.js